import { useEffect } from 'react';
import { reportInstanceResolutionFailed } from '@webble/wc-player';
import PlayerView from './components/PlayerView';
import ErrorScreen from './components/ErrorScreen';
import { parsePlayerRoute } from './lib/parsePlayerRoute';

function App() {
  const route = parsePlayerRoute(window.location.pathname, window.location.search);

  useEffect(() => {
    // The stream's instance isn't in our allow-list, so the player itself never
    // loads - report it from here instead (silently, see @webble/wc-player).
    if (route.error && route.streamUuid) {
      reportInstanceResolutionFailed(route.streamUuid);
    }
  }, [route.error, route.streamUuid]);

  if (route.error) {
    return <ErrorScreen title={route.error.title} message={route.error.message} />;
  }

  return (
    <PlayerView
      instanceUrl={route.instanceUrl}
      streamId={route.streamUuid}
      streamIdType={route.streamIdType}
    />
  );
}

export default App;
